<template>
<div class="chapter">
<div class="inner_page">
<h2>The Meeting of the Feeling</h2>
<ul>
<li><a href="#/index_split_000#toc_id_1">About the Author</a></li>
<li><a href="#/index_split_001#toc_id_2">Dedication</a></li>
<li><a href="#/index_split_002#id_OLE_LINK1">Copyright Information ©</a></li>
<li><a href="#/index_split_003#toc_id_3">Acknowledgement</a></li>
<li><a href="#/index_split_004#id_Toc172901704">Part 1: Ben’s Small World</a>
<ul>
<li><a href="#/index_split_005#id_Toc172901705">Chapter 1: Worry on the Way to Work</a></li>
<li><a href="#/index_split_006#id_Toc172901706">Chapter 2: Ben Fights Back</a></li>
<li><a href="#/index_split_007#id_Toc172901707">Chapter 3: A New Tutor</a></li>
<li><a href="#/index_split_008#id_Toc172901708">Chapter 4: Beer and A Bright Idea</a></li>
<li><a href="#/index_split_009#id_Toc172901709">Chapter 5: The New Order</a></li>
<li><a href="#/index_split_010#id_Toc172901710">Chapter 6: A Diversion</a></li>
<li><a href="#/index_split_011#id_Toc172901711">Chapter 7: Brendan’s Spanner</a></li>
<li><span href="#/index_split_012#id_Toc172901712" title="Link target outside of Sample">Chapter 8: A View of the Snakes</span></li>
<li><span href="#/index_split_013#id_Toc172901713" title="Link target outside of Sample">Chapter 9: A Meeting with the Man</span></li>
<li><span href="#/index_split_014#id_Toc172901714" title="Link target outside of Sample">Chapter 10: The Man in Action</span></li>
<li><span href="#/index_split_015#id_Toc172901715" title="Link target outside of Sample">Chapter 11: Kenny’s Great Scheme</span></li>
<li><span href="#/index_split_016#id_Toc172901716" title="Link target outside of Sample">Chapter 12: A Sense of Triumph</span></li>
<li><span href="#/index_split_017#id_Toc172901717" title="Link target outside of Sample">Chapter 13: Ben Considers His Options</span></li>
<li><span href="#/index_split_018#id_Toc172901718" title="Link target outside of Sample">Chapter 14: Two Surprises for Lindy</span></li>
<li><span href="#/index_split_019#id_Toc172901719" title="Link target outside of Sample">Chapter 15: An Unwelcome Complication?</span></li>
<li><span href="#/index_split_020#id_Toc172901720" title="Link target outside of Sample">Chapter 16: Ben’s Weakness, A DragonIs Disposed and An Innocent Saved</span></li>
<li><span href="#/index_split_021#id_Toc172901721" title="Link target outside of Sample">Chapter 17: Two Difficult Women, the Boy Wonder and An Upper-Class Twit</span></li>
<li><span href="#/index_split_022#id_Toc172901722" title="Link target outside of Sample">Chapter 18: Adds Versus the Boy Wonder</span></li>
<li><span href="#/index_split_023#id_Toc172901723" title="Link target outside of Sample">Chapter 19: A Tantrum andA Surprising Pub Lunch</span></li>
<li><span href="#/index_split_024#id_Toc172901724" title="Link target outside of Sample">Chapter 20: A Little Ladder andAn Enormous Snake</span></li>
<li><span href="#/index_split_025#id_Toc172901725" title="Link target outside of Sample">Chapter 21: Ben Moves inA Very High Place</span></li>
<li><span href="#/index_split_026#id_Toc172901726" title="Link target outside of Sample">Chapter 22: Ben Finds the Treasure</span></li>
<li><span href="#/index_split_027#id_Toc172901727" title="Link target outside of Sample">Chapter 23: A Let Down for Lindy ButA Good Result for the Lads</span></li>
<li><span href="#/index_split_028#id_Toc172901728" title="Link target outside of Sample">Chapter 24: Domestic Difficulties</span></li>
<li><span href="#/index_split_029#id_Toc172901729" title="Link target outside of Sample">Chapter 25: Ben Rescues Vic and FindsA New Victim</span></li>
<li><span href="#/index_split_030#id_Toc172901730" title="Link target outside of Sample">Chapter 26: Ben Pushes Andy Too Far?</span></li>
</ul>
</li>
<li><span href="#/index_split_031#id_Toc172901731" title="Link target outside of Sample">Part 2: The Other World</span>
<ul>
<li><span href="#/index_split_032#id_Toc172901732" title="Link target outside of Sample">Chapter 27: Some Advice,Orders and Progress</span></li>
<li><span href="#/index_split_033#id_Toc172901733" title="Link target outside of Sample">Chapter 28: Two Meetings</span></li>
<li><span href="#/index_split_034#id_Toc172901734" title="Link target outside of Sample">Chapter 29: Fall Out</span></li>
<li><span href="#/index_split_035#id_Toc172901735" title="Link target outside of Sample">Chapter 30: A Single Man</span></li>
<li><span href="#/index_split_036#id_Toc172901736" title="Link target outside of Sample">Chapter 31: Ultimatum</span></li>
<li><span href="#/index_split_037#id_Toc172901737" title="Link target outside of Sample">Chapter 32: Andy’s Women Troubles</span></li>
<li><span href="#/index_split_038#id_Toc172901738" title="Link target outside of Sample">Chapter 33: The Suspicions of Love</span></li>
<li><span href="#/index_split_039#id_Toc172901739" title="Link target outside of Sample">Chapter 34: Andy’sWoman Troubles Continue</span></li>
<li><span href="#/index_split_040#id_Toc172901740" title="Link target outside of Sample">Chapter 35: Andrea’s Debut</span></li>
<li><span href="#/index_split_041#id_Toc172901741" title="Link target outside of Sample">Chapter 36: Lindy’s Secret</span></li>
<li><span href="#/index_split_042#id_Toc172901742" title="Link target outside of Sample">Chapter 37: Bad News for Ben</span></li>
<li><span href="#/index_split_043#id_Toc172901743" title="Link target outside of Sample">Chapter 38: Lindy in London</span></li>
<li><span href="#/index_split_044#id_Toc172901744" title="Link target outside of Sample">Chapter 39: Lindy in London Part 2</span></li>
<li><span href="#/index_split_045#id_Toc172901745" title="Link target outside of Sample">Chapter 40: Life Without Lindy</span></li>
<li><span href="#/index_split_046#id_Toc172901746" title="Link target outside of Sample">Chapter 41: Consultation Day—Doug inthe Spotlight and Some Other Meetings</span></li>
<li><span href="#/index_split_047#id_Toc172901747" title="Link target outside of Sample">Chapter 42: A Trip to Brussels</span></li>
<li><span href="#/index_split_048#id_Toc172901748" title="Link target outside of Sample">Chapter 43: A Good Day for Dougand Problems for Cyril</span></li>
<li><span href="#/index_split_049#id_Toc172901749" title="Link target outside of Sample">Chapter 44: A Day of Decisions</span>
<ul>
<li><span href="#/index_split_049#id_Toc172901750" title="Link target outside of Sample">A Visitor for Lindy</span></li>
<li><span href="#/index_split_049#id_Toc172901751" title="Link target outside of Sample">Ben seeks advice</span></li>
</ul>
</li>
<li><span href="#/index_split_050#id_Toc172901752" title="Link target outside of Sample">Chapter 45: The PlayersSpeak for Themselves</span>
<ul>
<li><span href="#/index_split_050#id_Toc172901753" title="Link target outside of Sample">Cyril</span></li>
<li><span href="#/index_split_050#id_Toc172901754" title="Link target outside of Sample">Lindy</span></li>
<li><span href="#/index_split_050#id_Toc172901755" title="Link target outside of Sample">Sue</span></li>
<li><span href="#/index_split_050#id_Toc172901756" title="Link target outside of Sample">Trevor Hawkins</span></li>
<li><span href="#/index_split_050#id_Toc172901757" title="Link target outside of Sample">Ben</span></li>
<li><span href="#/index_split_050#id_Toc172901758" title="Link target outside of Sample">Kenny</span></li>
<li><span href="#/index_split_050#id_Toc172901759" title="Link target outside of Sample">Father Finbarr O’Riley</span></li>
<li><span href="#/index_split_050#id_Toc172901760" title="Link target outside of Sample">Andy</span></li>
</ul>
</li>
</ul>
</li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?c0ef0968